import { render, staticRenderFns } from "./OrderProductionFlow.vue?vue&type=template&id=22195d88&"
import script from "./OrderProductionFlow.vue?vue&type=script&lang=js&"
export * from "./OrderProductionFlow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports